"use client";

import ProductRecommendationCarousel from "../ProductRecommendationCarousel/ProductRecommendationCarousel";
import useGetViewedItemsFromLocalStorage from "@/hooks/useGetViewedItemsFromLocalStorage";
import { useI18n } from "@/i18n/client";

const RecentlyViewedCarousel = ({ id }: { id: number }) => {
	const t = useI18n();
	const { items, isLoadingItems } = useGetViewedItemsFromLocalStorage(id);

	if (!isLoadingItems && items.length === 0) {
		return null;
	}

	return (
		<ProductRecommendationCarousel
			placementProductId={String(id)}
			graphqlId='recently-viewed'
			products={items}
			title={t("Account.RecentlyViewed.recentlyViewed")}
			useProductCards
			isLoading={isLoadingItems}
			showAllProducts={true}
			data-eventname='Recently Viewed Products Viewed'
		/>
	);
};

export default RecentlyViewedCarousel;
